import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { ApolloError } from '@apollo/client'

import { isServerErrorVar, serverErrorMessageVar } from 'modulesCommon/store'

const useServerError = (serverErrors: any) => {
  const navigate = useNavigate()

  useEffect(() => {
    const serverError = serverErrors.find((item: ApolloError | undefined) => item)

    isServerErrorVar(!!serverError)

    if (!!serverError && serverError.message !== 'Unknown error') {
      serverErrorMessageVar(serverError.message)
      throw serverError
    }
  }, [serverErrors, navigate])
}

export default useServerError
